<template>
  <component :is="page" />
</template>
<script>
  const homePages = {
    Admin: () => import('./home-admin'),
    ClientAdmin: () => import('./home-client'),
    Client: () => import('./home-client'),
    ClientUser: () => import('./home-client'),
    ClientOrderer: () => import('./home-client'),
    ClientProvider: () => import('./home-client'),
    Patient: () => import('./home-patient')
  };

  export default {
    computed: {
      page() {
        return homePages[this.$auth.role];
      } 
    }
  }
</script>